export default __webpack_public_path__ + "d9759d62222e3b8c8232e696f5bf0c3f.svg";